import bp from '@bbl-digital/snorre/lib/globals/styles/breakpoints'
import styled from '@emotion/styled'

export const Wrapper = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;

  @media screen and (max-width: ${bp.small}) {
    flex-direction: column;
    gap: 0.5em;
  }
`
